// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VipRouteImport } from './routes/vip'
import { Route as TerminosRouteImport } from './routes/terminos'
import { Route as SobreBizacliaRouteImport } from './routes/sobre-bizaclia'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as PrensaRouteImport } from './routes/prensa'
import { Route as PortalVipRouteImport } from './routes/portal-vip'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as NewsRouteImport } from './routes/news'
import { Route as MybizacliaRouteImport } from './routes/mybizaclia'
import { Route as InvitacionVipRouteImport } from './routes/invitacion-vip'
import { Route as GuiaDelTraspasoRouteImport } from './routes/guia-del-traspaso'
import { Route as GuiaDelArrendadorRouteImport } from './routes/guia-del-arrendador'
import { Route as EstimadorViviendaRouteImport } from './routes/estimador-vivienda'
import { Route as EstimadorRouteImport } from './routes/estimador'
import { Route as EquipoRouteImport } from './routes/equipo'
import { Route as EmailGestionRouteImport } from './routes/email-gestion'
import { Route as EmailBajaRouteImport } from './routes/email-baja'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as ConfirmRouteImport } from './routes/confirm'
import { Route as ConectorVipRouteImport } from './routes/conector-vip'
import { Route as ConectorLightRouteImport } from './routes/conector-light'
import { Route as ConectorRouteImport } from './routes/conector'
import { Route as CalculadoraRouteImport } from './routes/calculadora'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AvisoLegalRouteImport } from './routes/aviso-legal'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AtChar123slugChar125RouteImport } from './routes/@{$slug}'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgenciaIndexRouteImport } from './routes/agencia.index'
import { Route as SeleccionTokenRouteImport } from './routes/seleccion.$token'
import { Route as LocalIdRouteImport } from './routes/local.$id'
import { Route as LocalVipIdRouteImport } from './routes/local-vip.$id'
import { Route as FirmarTokenRouteImport } from './routes/firmar.$token'
import { Route as AgenciaIdRouteImport } from './routes/agencia.$id'
import { Route as AgenciaScreenshotIdRouteImport } from './routes/agencia-screenshot.$id'
import { Route as PortalVipIndexRouteImport } from './routes/portal-vip.index'
import { Route as PortalVipFavoritosRouteImport } from './routes/portal-vip.favoritos'
import { Route as PortalVipDescartadosRouteImport } from './routes/portal-vip.descartados'
import { Route as PortalVipSplatRouteImport } from './routes/portal-vip.$'
import { Route as PortalIndexRouteImport } from './routes/portal.index'
import { Route as PortalFavoritosRouteImport } from './routes/portal.favoritos'
import { Route as PortalDescartadosRouteImport } from './routes/portal.descartados'
import { Route as PortalSplatRouteImport } from './routes/portal.$'
import { Route as NewsSlugRouteImport } from './routes/news.$slug'
import { Route as MybizacliaIndexRouteImport } from './routes/mybizaclia.index'
import { Route as ConectorVipChar123IdChar125RouteImport } from './routes/conector-vip.{-$id}'
import { Route as ConectorLightChar123IdChar125RouteImport } from './routes/conector-light.{-$id}'
import { Route as ConectorChar123IdChar125RouteImport } from './routes/conector.{-$id}'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminTramitesRouteImport } from './routes/admin.tramites'
import { Route as AdminTareasRouteImport } from './routes/admin.tareas'
import { Route as AdminStatsRouteImport } from './routes/admin.stats'
import { Route as AdminSolicitudesRouteImport } from './routes/admin.solicitudes'
import { Route as AdminPublicacionesRouteImport } from './routes/admin.publicaciones'
import { Route as AdminPersonasRouteImport } from './routes/admin.personas'
import { Route as AdminPermisosRouteImport } from './routes/admin.permisos'
import { Route as AdminOperacionesRouteImport } from './routes/admin.operaciones'
import { Route as AdminHerramientasRouteImport } from './routes/admin.herramientas'
import { Route as AdminEstimadorViviendaRouteImport } from './routes/admin.estimador-vivienda'
import { Route as AdminEstimadorRouteImport } from './routes/admin.estimador'
import { Route as AdminEquipoRouteImport } from './routes/admin.equipo'
import { Route as AdminDemandasRouteImport } from './routes/admin.demandas'
import { Route as AdminDatosRouteImport } from './routes/admin.datos'
import { Route as AdminComunicacionRouteImport } from './routes/admin.comunicacion'
import { Route as AdminCaptacionRouteImport } from './routes/admin.captacion'
import { Route as AdminCampanasRouteImport } from './routes/admin.campanas'
import { Route as AdminBaseConocimientoRouteImport } from './routes/admin.base-conocimiento'
import { Route as AdminAnunciosRouteImport } from './routes/admin.anuncios'
import { Route as AdminAgendaRouteImport } from './routes/admin.agenda'
import { Route as AdminAgenciasRouteImport } from './routes/admin.agencias'
import { Route as AdminAcademiaRouteImport } from './routes/admin.academia'
import { Route as MybizacliaSolicitudesIdRouteImport } from './routes/mybizaclia.solicitudes.$id'
import { Route as AdminToolsIndexRouteImport } from './routes/admin.tools.index'
import { Route as AdminPlataformaLocalesRouteImport } from './routes/admin.plataforma.locales'
import { Route as AdminPlataformaIdentidadesRouteImport } from './routes/admin.plataforma.identidades'

const VipRoute = VipRouteImport.update({
            id: '/vip',path: '/vip',getParentRoute: () => rootRouteImport
          })
const TerminosRoute = TerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => rootRouteImport
          })
const SobreBizacliaRoute = SobreBizacliaRouteImport.update({
            id: '/sobre-bizaclia',path: '/sobre-bizaclia',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const PrensaRoute = PrensaRouteImport.update({
            id: '/prensa',path: '/prensa',getParentRoute: () => rootRouteImport
          })
const PortalVipRoute = PortalVipRouteImport.update({
            id: '/portal-vip',path: '/portal-vip',getParentRoute: () => rootRouteImport
          })
const PortalRoute = PortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const MybizacliaRoute = MybizacliaRouteImport.update({
            id: '/mybizaclia',path: '/mybizaclia',getParentRoute: () => rootRouteImport
          })
const InvitacionVipRoute = InvitacionVipRouteImport.update({
            id: '/invitacion-vip',path: '/invitacion-vip',getParentRoute: () => rootRouteImport
          })
const GuiaDelTraspasoRoute = GuiaDelTraspasoRouteImport.update({
            id: '/guia-del-traspaso',path: '/guia-del-traspaso',getParentRoute: () => rootRouteImport
          })
const GuiaDelArrendadorRoute = GuiaDelArrendadorRouteImport.update({
            id: '/guia-del-arrendador',path: '/guia-del-arrendador',getParentRoute: () => rootRouteImport
          })
const EstimadorViviendaRoute = EstimadorViviendaRouteImport.update({
            id: '/estimador-vivienda',path: '/estimador-vivienda',getParentRoute: () => rootRouteImport
          })
const EstimadorRoute = EstimadorRouteImport.update({
            id: '/estimador',path: '/estimador',getParentRoute: () => rootRouteImport
          })
const EquipoRoute = EquipoRouteImport.update({
            id: '/equipo',path: '/equipo',getParentRoute: () => rootRouteImport
          })
const EmailGestionRoute = EmailGestionRouteImport.update({
            id: '/email-gestion',path: '/email-gestion',getParentRoute: () => rootRouteImport
          })
const EmailBajaRoute = EmailBajaRouteImport.update({
            id: '/email-baja',path: '/email-baja',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ContactoRoute = ContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => rootRouteImport
          })
const ConfirmRoute = ConfirmRouteImport.update({
            id: '/confirm',path: '/confirm',getParentRoute: () => rootRouteImport
          })
const ConectorVipRoute = ConectorVipRouteImport.update({
            id: '/conector-vip',path: '/conector-vip',getParentRoute: () => rootRouteImport
          })
const ConectorLightRoute = ConectorLightRouteImport.update({
            id: '/conector-light',path: '/conector-light',getParentRoute: () => rootRouteImport
          })
const ConectorRoute = ConectorRouteImport.update({
            id: '/conector',path: '/conector',getParentRoute: () => rootRouteImport
          })
const CalculadoraRoute = CalculadoraRouteImport.update({
            id: '/calculadora',path: '/calculadora',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AvisoLegalRoute = AvisoLegalRouteImport.update({
            id: '/aviso-legal',path: '/aviso-legal',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AtChar123slugChar125Route = AtChar123slugChar125RouteImport.update({
            id: '/@{$slug}',path: '/@{$slug}',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AgenciaIndexRoute = AgenciaIndexRouteImport.update({
            id: '/agencia/',path: '/agencia/',getParentRoute: () => rootRouteImport
          })
const SeleccionTokenRoute = SeleccionTokenRouteImport.update({
            id: '/seleccion/$token',path: '/seleccion/$token',getParentRoute: () => rootRouteImport
          })
const LocalIdRoute = LocalIdRouteImport.update({
            id: '/local/$id',path: '/local/$id',getParentRoute: () => rootRouteImport
          })
const LocalVipIdRoute = LocalVipIdRouteImport.update({
            id: '/local-vip/$id',path: '/local-vip/$id',getParentRoute: () => rootRouteImport
          })
const FirmarTokenRoute = FirmarTokenRouteImport.update({
            id: '/firmar/$token',path: '/firmar/$token',getParentRoute: () => rootRouteImport
          })
const AgenciaIdRoute = AgenciaIdRouteImport.update({
            id: '/agencia/$id',path: '/agencia/$id',getParentRoute: () => rootRouteImport
          })
const AgenciaScreenshotIdRoute = AgenciaScreenshotIdRouteImport.update({
            id: '/agencia-screenshot/$id',path: '/agencia-screenshot/$id',getParentRoute: () => rootRouteImport
          })
const PortalVipIndexRoute = PortalVipIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalVipRoute
          })
const PortalVipFavoritosRoute = PortalVipFavoritosRouteImport.update({
            id: '/favoritos',path: '/favoritos',getParentRoute: () => PortalVipRoute
          })
const PortalVipDescartadosRoute = PortalVipDescartadosRouteImport.update({
            id: '/descartados',path: '/descartados',getParentRoute: () => PortalVipRoute
          })
const PortalVipSplatRoute = PortalVipSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => PortalVipRoute
          })
const PortalIndexRoute = PortalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortalRoute
          })
const PortalFavoritosRoute = PortalFavoritosRouteImport.update({
            id: '/favoritos',path: '/favoritos',getParentRoute: () => PortalRoute
          })
const PortalDescartadosRoute = PortalDescartadosRouteImport.update({
            id: '/descartados',path: '/descartados',getParentRoute: () => PortalRoute
          })
const PortalSplatRoute = PortalSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => PortalRoute
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => NewsRoute
          })
const MybizacliaIndexRoute = MybizacliaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MybizacliaRoute
          })
const ConectorVipChar123IdChar125Route = ConectorVipChar123IdChar125RouteImport.update({
            id: '/{-$id}',path: '/{-$id}',getParentRoute: () => ConectorVipRoute
          })
const ConectorLightChar123IdChar125Route = ConectorLightChar123IdChar125RouteImport.update({
            id: '/{-$id}',path: '/{-$id}',getParentRoute: () => ConectorLightRoute
          })
const ConectorChar123IdChar125Route = ConectorChar123IdChar125RouteImport.update({
            id: '/{-$id}',path: '/{-$id}',getParentRoute: () => ConectorRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminTramitesRoute = AdminTramitesRouteImport.update({
            id: '/tramites',path: '/tramites',getParentRoute: () => AdminRoute
          })
const AdminTareasRoute = AdminTareasRouteImport.update({
            id: '/tareas',path: '/tareas',getParentRoute: () => AdminRoute
          })
const AdminStatsRoute = AdminStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => AdminRoute
          })
const AdminSolicitudesRoute = AdminSolicitudesRouteImport.update({
            id: '/solicitudes',path: '/solicitudes',getParentRoute: () => AdminRoute
          })
const AdminPublicacionesRoute = AdminPublicacionesRouteImport.update({
            id: '/publicaciones',path: '/publicaciones',getParentRoute: () => AdminRoute
          })
const AdminPersonasRoute = AdminPersonasRouteImport.update({
            id: '/personas',path: '/personas',getParentRoute: () => AdminRoute
          })
const AdminPermisosRoute = AdminPermisosRouteImport.update({
            id: '/permisos',path: '/permisos',getParentRoute: () => AdminRoute
          })
const AdminOperacionesRoute = AdminOperacionesRouteImport.update({
            id: '/operaciones',path: '/operaciones',getParentRoute: () => AdminRoute
          })
const AdminHerramientasRoute = AdminHerramientasRouteImport.update({
            id: '/herramientas',path: '/herramientas',getParentRoute: () => AdminRoute
          })
const AdminEstimadorViviendaRoute = AdminEstimadorViviendaRouteImport.update({
            id: '/estimador-vivienda',path: '/estimador-vivienda',getParentRoute: () => AdminRoute
          })
const AdminEstimadorRoute = AdminEstimadorRouteImport.update({
            id: '/estimador',path: '/estimador',getParentRoute: () => AdminRoute
          })
const AdminEquipoRoute = AdminEquipoRouteImport.update({
            id: '/equipo',path: '/equipo',getParentRoute: () => AdminRoute
          })
const AdminDemandasRoute = AdminDemandasRouteImport.update({
            id: '/demandas',path: '/demandas',getParentRoute: () => AdminRoute
          })
const AdminDatosRoute = AdminDatosRouteImport.update({
            id: '/datos',path: '/datos',getParentRoute: () => AdminRoute
          })
const AdminComunicacionRoute = AdminComunicacionRouteImport.update({
            id: '/comunicacion',path: '/comunicacion',getParentRoute: () => AdminRoute
          })
const AdminCaptacionRoute = AdminCaptacionRouteImport.update({
            id: '/captacion',path: '/captacion',getParentRoute: () => AdminRoute
          })
const AdminCampanasRoute = AdminCampanasRouteImport.update({
            id: '/campanas',path: '/campanas',getParentRoute: () => AdminRoute
          })
const AdminBaseConocimientoRoute = AdminBaseConocimientoRouteImport.update({
            id: '/base-conocimiento',path: '/base-conocimiento',getParentRoute: () => AdminRoute
          })
const AdminAnunciosRoute = AdminAnunciosRouteImport.update({
            id: '/anuncios',path: '/anuncios',getParentRoute: () => AdminRoute
          })
const AdminAgendaRoute = AdminAgendaRouteImport.update({
            id: '/agenda',path: '/agenda',getParentRoute: () => AdminRoute
          })
const AdminAgenciasRoute = AdminAgenciasRouteImport.update({
            id: '/agencias',path: '/agencias',getParentRoute: () => AdminRoute
          })
const AdminAcademiaRoute = AdminAcademiaRouteImport.update({
            id: '/academia',path: '/academia',getParentRoute: () => AdminRoute
          })
const MybizacliaSolicitudesIdRoute = MybizacliaSolicitudesIdRouteImport.update({
            id: '/solicitudes/$id',path: '/solicitudes/$id',getParentRoute: () => MybizacliaRoute
          })
const AdminToolsIndexRoute = AdminToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => AdminRoute
          })
const AdminPlataformaLocalesRoute = AdminPlataformaLocalesRouteImport.update({
            id: '/plataforma/locales',path: '/plataforma/locales',getParentRoute: () => AdminRoute
          })
const AdminPlataformaIdentidadesRoute = AdminPlataformaIdentidadesRouteImport.update({
            id: '/plataforma/identidades',path: '/plataforma/identidades',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminAcademiaRoute: AdminAcademiaRoute,AdminAgenciasRoute: AdminAgenciasRoute,AdminAgendaRoute: AdminAgendaRoute,AdminAnunciosRoute: AdminAnunciosRoute,AdminBaseConocimientoRoute: AdminBaseConocimientoRoute,AdminCampanasRoute: AdminCampanasRoute,AdminCaptacionRoute: AdminCaptacionRoute,AdminComunicacionRoute: AdminComunicacionRoute,AdminDatosRoute: AdminDatosRoute,AdminDemandasRoute: AdminDemandasRoute,AdminEquipoRoute: AdminEquipoRoute,AdminEstimadorRoute: AdminEstimadorRoute,AdminEstimadorViviendaRoute: AdminEstimadorViviendaRoute,AdminHerramientasRoute: AdminHerramientasRoute,AdminOperacionesRoute: AdminOperacionesRoute,AdminPermisosRoute: AdminPermisosRoute,AdminPersonasRoute: AdminPersonasRoute,AdminPublicacionesRoute: AdminPublicacionesRoute,AdminSolicitudesRoute: AdminSolicitudesRoute,AdminStatsRoute: AdminStatsRoute,AdminTareasRoute: AdminTareasRoute,AdminTramitesRoute: AdminTramitesRoute,AdminIndexRoute: AdminIndexRoute,AdminPlataformaIdentidadesRoute: AdminPlataformaIdentidadesRoute,AdminPlataformaLocalesRoute: AdminPlataformaLocalesRoute,AdminToolsIndexRoute: AdminToolsIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const ConectorRouteChildren = {
  ConectorChar123IdChar125Route: ConectorChar123IdChar125Route
}

const ConectorRouteWithChildren = ConectorRoute._addFileChildren(ConectorRouteChildren)




const ConectorLightRouteChildren = {
  ConectorLightChar123IdChar125Route: ConectorLightChar123IdChar125Route
}

const ConectorLightRouteWithChildren = ConectorLightRoute._addFileChildren(ConectorLightRouteChildren)




const ConectorVipRouteChildren = {
  ConectorVipChar123IdChar125Route: ConectorVipChar123IdChar125Route
}

const ConectorVipRouteWithChildren = ConectorVipRoute._addFileChildren(ConectorVipRouteChildren)




const MybizacliaRouteChildren = {
  MybizacliaIndexRoute: MybizacliaIndexRoute,MybizacliaSolicitudesIdRoute: MybizacliaSolicitudesIdRoute
}

const MybizacliaRouteWithChildren = MybizacliaRoute._addFileChildren(MybizacliaRouteChildren)




const NewsRouteChildren = {
  NewsSlugRoute: NewsSlugRoute
}

const NewsRouteWithChildren = NewsRoute._addFileChildren(NewsRouteChildren)




const PortalRouteChildren = {
  PortalSplatRoute: PortalSplatRoute,PortalDescartadosRoute: PortalDescartadosRoute,PortalFavoritosRoute: PortalFavoritosRoute,PortalIndexRoute: PortalIndexRoute
}

const PortalRouteWithChildren = PortalRoute._addFileChildren(PortalRouteChildren)




const PortalVipRouteChildren = {
  PortalVipSplatRoute: PortalVipSplatRoute,PortalVipDescartadosRoute: PortalVipDescartadosRoute,PortalVipFavoritosRoute: PortalVipFavoritosRoute,PortalVipIndexRoute: PortalVipIndexRoute
}

const PortalVipRouteWithChildren = PortalVipRoute._addFileChildren(PortalVipRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AtChar123slugChar125Route: AtChar123slugChar125Route,AdminRoute: AdminRouteWithChildren,AvisoLegalRoute: AvisoLegalRoute,BlogRoute: BlogRoute,CalculadoraRoute: CalculadoraRoute,ConectorRoute: ConectorRouteWithChildren,ConectorLightRoute: ConectorLightRouteWithChildren,ConectorVipRoute: ConectorVipRouteWithChildren,ConfirmRoute: ConfirmRoute,ContactoRoute: ContactoRoute,CookiesRoute: CookiesRoute,EmailBajaRoute: EmailBajaRoute,EmailGestionRoute: EmailGestionRoute,EquipoRoute: EquipoRoute,EstimadorRoute: EstimadorRoute,EstimadorViviendaRoute: EstimadorViviendaRoute,GuiaDelArrendadorRoute: GuiaDelArrendadorRoute,GuiaDelTraspasoRoute: GuiaDelTraspasoRoute,InvitacionVipRoute: InvitacionVipRoute,MybizacliaRoute: MybizacliaRouteWithChildren,NewsRoute: NewsRouteWithChildren,PortalRoute: PortalRouteWithChildren,PortalVipRoute: PortalVipRouteWithChildren,PrensaRoute: PrensaRoute,PrivacidadRoute: PrivacidadRoute,ResetPasswordRoute: ResetPasswordRoute,SobreBizacliaRoute: SobreBizacliaRoute,TerminosRoute: TerminosRoute,VipRoute: VipRoute,AgenciaScreenshotIdRoute: AgenciaScreenshotIdRoute,AgenciaIdRoute: AgenciaIdRoute,FirmarTokenRoute: FirmarTokenRoute,LocalVipIdRoute: LocalVipIdRoute,LocalIdRoute: LocalIdRoute,SeleccionTokenRoute: SeleccionTokenRoute,AgenciaIndexRoute: AgenciaIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)